"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-ten/sections/testimonialSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TestimonialSectionTestimonialBg02sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/bg/testimonial-bg-04.png" | "/Templates/Doccure/img/bg/testimonial-bg-05.png" */
    src: string;
    /** Detected variants: "bg" */
    alt?: string;
    /** Detected variants: "testimonial-bg-02" */
    className?: string;
};

type TestimonialSectionSlidersItem = {
    key: Key | null | undefined;
    /** Detected variants: "A Dream Finally Fulfilled" | "We finally feel complete" */
    h30Text?: ReactNode;
    /** Detected variants: "custom-title" */
    className?: string;
    /** Detected variants: "After a long journey filled with doubts, the team stood by us with unwavering kindness and clarity. Their dedication gave us strength, and today we’re blessed." | "After years of uncertainty, the team guided us with patience and compassion. Their support made all the difference, and today we’re holding our little miracle." | "We walked in with worries, but their guidance replaced our fears with hope. Thanks to their constant support and gentle care, our miracle is now a beautiful reality." */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/patients/patient20.jpg" | "/Templates/Doccure/img/patients/patient23.jpg" | "/Templates/Doccure/img/patients/patient25.jpg" */
    src: string;
    /** Detected variants: "Lauren Parker" | "Elizabeth Clifford" | "Catherine Moss" */
    p0P0Text: ReactNode;
    /** Detected variants: "slider-item" */
    divClassName?: string;
    /** Detected variants: "testimonial-item-ten" */
    div0ClassName?: string;
    /** Detected variants: "testimonials-info" */
    div0ClassName2?: string;
    /** Detected variants: "quote-icon" */
    div0ClassName3?: string;
    /** Detected variants: "quote" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/quote-icon-04.svg" */
    imageWithBasePath0Src?: string;
    /** Detected variants: "testimonial-content" */
    div2ClassName?: string;
    /** Detected variants: "testimonial-author-info" */
    div3ClassName?: string;
    /** Detected variants: "testimonial-author-img" */
    div0ClassName4?: string;
    /** Detected variants: "patient" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "rounded-circle" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "author-name" */
    p0ClassName?: string;
    ratingItems?: TestimonialSectionFaSolidFaStarFilled1s2Item[];
};

type TestimonialSectionFaSolidFaStarFilled1s2Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-solid fa-star filled me-1" | "fa-solid fa-star filled" */
    className: string;
};
const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    vertical: true,
    verticalSwiping: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                vertical: false,
                verticalSwiping: false,
            },
        },
    ],
};

export type HomeTenTestimonialSectionGeneratedProps = {
    divDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Div2H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSectionSlidersItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div0Div3Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    imageWithBasePathImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionTestimonialBg02sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "Why Choose Us" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Stories of Hope & Happiness" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "reviews" */
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/reviews/testimonial-02.jpg" */
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div0Div1Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/testimonial-bg-03.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    testimonialSectionTestimonialBg02s: TestimonialSectionTestimonialBg02sItem[];
    testimonialSectionSliders: TestimonialSectionSlidersItem[];
    testimonialSectionTestimonialBg02sItemWrapper?: (item: TestimonialSectionTestimonialBg02sItem, content: ReactNode) => ReactNode;
    testimonialSectionTestimonialBg02sRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSectionTestimonialBg02sImageVisible?: boolean;
    testimonialSectionTestimonialBg02sImageRenderer?: (item: TestimonialSectionTestimonialBg02sItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionTestimonialBg02sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionTestimonialBg02sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialSectionSlidersItemWrapper?: (item: TestimonialSectionSlidersItem, content: ReactNode) => ReactNode;
    testimonialSectionSlidersRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidersImageVisible?: boolean;
    testimonialSectionSlidersImageRenderer?: (item: TestimonialSectionSlidersItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidersH3Visible?: boolean;
    testimonialSectionSlidersH3Renderer?: (item: TestimonialSectionSlidersItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidersImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialSectionSlidersH3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSectionSlidersItem) => Partial<ComponentProps<"h3">>);
    testimonialSectionFaSolidFaStarFilled1s2ItemWrapper?: (item: TestimonialSectionFaSolidFaStarFilled1s2Item, content: ReactNode) => ReactNode;
    testimonialSectionFaSolidFaStarFilled1s2Renderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeTenTestimonialSectionGenerated: FC<HomeTenTestimonialSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivText = "Why Choose Us",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0H20H2Text = "Stories of Hope & Happiness",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageAlt = "reviews",
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/reviews/testimonial-02.jpg",
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/testimonial-bg-03.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Div2H30H3Props,
    divDiv0Div0Div3Div0ImageWithBasePath0ImageProps,
    imageWithBasePathImageProps,
    sectionDiv0Div0Div1Slider0SliderProps,
    sectionDiv0Div0ClassName,
    testimonialSectionTestimonialBg02s,
    testimonialSectionSliders,
    testimonialSectionTestimonialBg02sItemWrapper,
    testimonialSectionTestimonialBg02sRenderer,
    testimonialSectionTestimonialBg02sImageVisible,
    testimonialSectionTestimonialBg02sImageRenderer,
    testimonialSectionTestimonialBg02sImageProps,
    testimonialSectionSlidersItemWrapper,
    testimonialSectionSlidersRenderer,
    testimonialSectionSlidersImageVisible,
    testimonialSectionSlidersImageRenderer,
    testimonialSectionSlidersH3Visible,
    testimonialSectionSlidersH3Renderer,
    testimonialSectionSlidersImageProps,
    testimonialSectionSlidersH3Props,
    testimonialSectionFaSolidFaStarFilled1s2ItemWrapper,
    testimonialSectionFaSolidFaStarFilled1s2Renderer,
}) => {
    return (
        <section className="testimonial-section-ten section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                    <div className="col-lg-7">
                        <div className="section-header section-header-ten wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            <div className="section-sub-title">
                                <span className="sec-circle" aria-hidden="true" />
                                {sectionDiv0Div0Div0Div0Div0DivText}
                            </div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0H20H2Text}</h2>
                            ))}
                        </div>
                        <div className="testimonial-image-ten">
                            {renderNode(sectionDiv0Div0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div1ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div1ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <Slider {...settings} className="testimonial-slider-ten" {...(sectionDiv0Div0Div1Slider0SliderProps ?? {})}>
                            {renderCollectionNode(
                                testimonialSectionSliders,
                                (item: TestimonialSectionSlidersItem) => (
                                    <div className={item.divClassName ?? "slider-item"} key={item.key}>
                                        <div className={item.div0ClassName ?? "testimonial-item-ten"}>
                                            <div className={item.div0ClassName2 ?? "testimonials-info"}>
                                                <div className={item.div0ClassName3 ?? "quote-icon"}>
                                                    {renderItemNode(testimonialSectionSlidersImageVisible, testimonialSectionSlidersImageRenderer, item, (
                                                        <SmartImage src={item.imageWithBasePath0Src ?? "/Templates/Doccure/img/icons/quote-icon-04.svg"} alt={item.alt ?? "quote"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof testimonialSectionSlidersImageProps === "function" ? testimonialSectionSlidersImageProps(item) : (testimonialSectionSlidersImageProps ?? {}))} {...(typeof divDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </div>
                                                <div className="rating">
                                                    {renderCollectionNode(
                                                        item.ratingItems ?? [],
                                                        (item: TestimonialSectionFaSolidFaStarFilled1s2Item) => (
                                                            <i className={item.className} key={item.key} />
                                                        ),
                                                        testimonialSectionFaSolidFaStarFilled1s2ItemWrapper,
                                                        testimonialSectionFaSolidFaStarFilled1s2Renderer
                                                    )}
                                                </div>
                                                <div className={item.div2ClassName ?? "testimonial-content"}>
                                                    {renderItemNode(testimonialSectionSlidersH3Visible, testimonialSectionSlidersH3Renderer, item, (
                                                        <h3 className={item.className} {...(typeof testimonialSectionSlidersH3Props === "function" ? testimonialSectionSlidersH3Props(item) : (testimonialSectionSlidersH3Props ?? {}))} {...(typeof divDiv0Div0Div2H30H3Props === "function" ? divDiv0Div0Div2H30H3Props(item) : (divDiv0Div0Div2H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                    ))}
                                                    <p>{item.p0Text}</p>
                                                </div>
                                                <div className={item.div3ClassName ?? "testimonial-author-info"}>
                                                    <div className={item.div0ClassName4 ?? "testimonial-author-img"}>
                                                        {renderItemNode(testimonialSectionSlidersImageVisible, testimonialSectionSlidersImageRenderer, item, (
                                                            <SmartImage src={item.src} className={item.imageWithBasePath0ClassName2 ?? "rounded-circle"} alt={item.imageWithBasePath0Alt ?? "patient"} {...(typeof testimonialSectionSlidersImageProps === "function" ? testimonialSectionSlidersImageProps(item) : (testimonialSectionSlidersImageProps ?? {}))} {...(typeof divDiv0Div0Div3Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div3Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div3Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                        ))}
                                                    </div>
                                                    <div>
                                                        <p className={item.p0ClassName ?? "author-name"}>{item.p0P0Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ),
                                testimonialSectionSlidersItemWrapper,
                                testimonialSectionSlidersRenderer
                            )}
                        </Slider>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="testimonial-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderCollectionNode(
                testimonialSectionTestimonialBg02s,
                (item: TestimonialSectionTestimonialBg02sItem) => (
                    renderItemNode(testimonialSectionTestimonialBg02sImageVisible, testimonialSectionTestimonialBg02sImageRenderer, item, (
                        <SmartImage src={item.src} alt={item.alt ?? "bg"} className={item.className ?? "testimonial-bg-02"} {...(typeof testimonialSectionTestimonialBg02sImageProps === "function" ? testimonialSectionTestimonialBg02sImageProps(item) : (testimonialSectionTestimonialBg02sImageProps ?? {}))} {...(typeof imageWithBasePathImageProps === "function" ? imageWithBasePathImageProps(item) : (imageWithBasePathImageProps ?? {}))} key={item.key} />
                    ))
                ),
                testimonialSectionTestimonialBg02sItemWrapper,
                testimonialSectionTestimonialBg02sRenderer
            )}
        </section>
    );
};

export default HomeTenTestimonialSectionGenerated;
